import instance from './API';
import { trim } from 'lodash';

const memberAPI = {
  getMember: (userId) => {
    return instance.get(`/Member/${userId}`);
  },
  getMemberList: (page, count, memberType, keyword) => {
    const params = {
      page: page,
      count: count,
      memberType: memberType,
      keyword: keyword,
    };

    return instance.get('/Member', {
      params: params,
    });
  },
  upgradePayingMember: (userId, payingMemberPlanId, consignmentUserId) => {
    return instance.get(`/Member/ActivePayingMember`, {
      params: {
        userId,
        PayingMemberPlanId: trim(payingMemberPlanId),
        consignmentUserId: trim(consignmentUserId)
          ? consignmentUserId
          : undefined,
      },
    });
  },
  checkPayingMember: (qrcode) => {
    return instance.get(`/Member/VerifyPayingMember`, {
      params: {
        qrcode: trim(qrcode),
      },
    });
  },
  getAllPayingMemberPlans: (storeId = null) => {
    return instance.get('/PayingMember/Price', {
      params: {
        storeId: trim(storeId) !== '' ? storeId : undefined,
      },
    });
  },
  getPayingMemberPlans: (page, count, storeId = null, status = null) => {
    return instance.get('/Member/PayingMember/Plans', {
      params: {
        page: page,
        count: count,
        storeId: trim(storeId) !== '' ? storeId : -1,
        status: status !== null ? status : undefined,
      },
    });
  },
  getPayingMemberPlan: (payingMemberPlanId) => {
    return instance.get(`/Member/PayingMember/Plan/${payingMemberPlanId}`);
  },
  createOrUpdatePayingMemberPlan: (payingMemberPlan) => {
    let params = new URLSearchParams();

    if (trim(payingMemberPlan.id) !== '') {
      params.append('Id', payingMemberPlan.id);
    }

    params.append('Name', payingMemberPlan.name);
    params.append('Price', payingMemberPlan.price);
    params.append('ProductPackageId', payingMemberPlan.productPackageId);
    params.append('Barcode', payingMemberPlan.barcode);
    params.append('StoreId', payingMemberPlan.storeId);
    params.append('Status', payingMemberPlan.status);

    return instance.post('/Member/PayingMember/Plan', params);
  },
  getUserPayingMembers: (page, count, startAt, endAt, keyword) => {
    const params = {
      page: page,
      count: count,
      startAt: trim(startAt) !== '' ? startAt : '',
      endAt: trim(endAt) !== '' ? endAt : '',
    };

    if (trim(keyword) !== '') {
      params.keyword = keyword;
    }

    return instance.get('/MemberTransaction', {
      params: params,
    });
  },
  cancelPayingMember: (userPayingMemberId) => {
    return instance.delete('/Member/DeactivePayingMember', {
      params: {
        userPayingMemberId: userPayingMemberId,
      },
    });
  },
  addOrEditDepartment: (department, companyId, userId) => {
    const params = new URLSearchParams();
    params.append('Department', department);
    params.append('CompanyId', companyId);
    params.append('UserId', userId);
    return instance.post('/member/department', params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  },
  deleteDepartment: (memberCompanyId) => {
    return instance.delete(`/member/department/${memberCompanyId}`);
  },
  getCompanyList: () => {
    return instance.get('/Company');
  },
  claimDigitalCoupon: (userPayingMemberId) => {
    return instance.post('/Member/PayingMember/Link', null, {
      params: {
        userPayingMemberId: userPayingMemberId,
      },
    });
  },
  restorePayingMemberClaimStatus: (userPayingMemberId) => {
    return instance.post('/Member/PayingMember/Restore', null, {
      params: {
        userPayingMemberId: userPayingMemberId,
      },
    });
  },
  updateBirthday: (userId, birthday) => {
    return instance.put('/Member/UpdateBirthday', null, {
      params: { userId, birthday },
    });
  },
  transferPayingMember: (userPayingMemberId, targetUserId) => {
    let params = new URLSearchParams();
    params.append('UserPayingMemberId', userPayingMemberId);
    params.append('TargetUserId', targetUserId);
    return instance.post('/Member/PayingMember/Transfer', params);
  },
};

export default memberAPI;
